var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H22.8889C30.6209 0 36.8889 6.26801 36.8889 14V22C36.8889 29.732 30.6209 36 22.8889 36H14C6.268 36 0 29.732 0 22V14Z",
    fill: "#CCEBF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 22.4444C22.3515 22.4444 21.5556 23.2404 21.5556 24.2222C21.5556 25.2041 22.3515 26 23.3333 26C24.3152 26 25.1111 25.2041 25.1111 24.2222C25.1111 23.2404 24.3152 22.4444 23.3333 22.4444ZM23.3333 22.4444H14.7709C14.3286 22.4444 13.9535 22.1192 13.891 21.6813L13.619 19.7778M10 10H12.2222L12.4762 11.7778M12.4762 11.7778H12.6667H26.8889L24.2222 19.7778H14H13.619M12.4762 11.7778L13.619 19.7778M18 24.2222C18 25.2041 17.2041 26 16.2222 26C15.2404 26 14.4444 25.2041 14.4444 24.2222C14.4444 23.2404 15.2404 22.4444 16.2222 22.4444C17.2041 22.4444 18 23.2404 18 24.2222Z",
    stroke: "#009DDB",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBtn);
export default __webpack_public_path__ + "static/media/cart-btn.ed26b8210e2dfacc0b2d5971ad58b16d.svg";
export { ForwardRef as ReactComponent };